'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _tether = require('tether');

var _tether2 = _interopRequireDefault(_tether);

var _sizes = require('HubStyleTokens/sizes');

var _PlacementConstants = require('./PlacementConstants');

var _Functions = require('../core/Functions');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _RootNode = require('../utils/RootNode');

var _Dom = require('../utils/Dom');

var _underscore = require('../utils/underscore');

var _Placement = require('./utils/Placement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NUMBERS_REGEX = /\d+/g;
var DUMMY_ELEMENT = document.createElement('span');

var makeLayerNode = function makeLayerNode(zIndex) {
  var node = document.createElement('div');
  // add z-index for compatibility with other "layered" stuff like vex
  node.style.zIndex = zIndex;
  // position fixed prevents a screen jump when the container mounts
  node.style.position = 'fixed';
  node.style.top = '0px';
  return node;
};

var getDummyElement = function getDummyElement(bodyElement) {
  // IE11 throws an error if we try to initialize Tether with an element
  // that isn't in the DOM: HubSpot/UIComponents#1058
  if (!DUMMY_ELEMENT.parentElement) {
    bodyElement.appendChild(DUMMY_ELEMENT);
  }
  return DUMMY_ELEMENT;
};

var getTabTargetFromWithinPopup = function getTabTargetFromWithinPopup(popopEl, activeEl, reverseTab, targetEl) {
  var tabbableElsWithinPopup = (0, _Dom.getTabbableElements)(popopEl);

  if (!reverseTab && activeEl === (0, _underscore.last)(tabbableElsWithinPopup)) {
    // Tab out of the popup to the tabbable element after the target (exclusive).
    return (0, _Dom.getNextTabbableElementExclusive)(targetEl);
  } else if (reverseTab && activeEl === (0, _underscore.first)(tabbableElsWithinPopup)) {
    // Tab out of the popup to the tabbable element before the target (inclusive).
    return (0, _Dom.getPrevTabbableElementInclusive)(targetEl);
  }

  return null;
};

var UIAbstractPopup = function (_PureComponent) {
  _inherits(UIAbstractPopup, _PureComponent);

  function UIAbstractPopup(props) {
    _classCallCheck(this, UIAbstractPopup);

    var _this = _possibleConstructorReturn(this, (UIAbstractPopup.__proto__ || Object.getPrototypeOf(UIAbstractPopup)).call(this, props));

    _this.state = {
      targetIsOutOfBounds: false,
      targetIsInTransition: false
    };

    _this.handleTetherUpdate = _this.handleTetherUpdate.bind(_this);
    _this.handleImageLoad = _this.handleImageLoad.bind(_this);
    _this.handleWindowFocus = _this.handleWindowFocus.bind(_this);
    _this.handleWindowKeyDown = _this.handleWindowKeyDown.bind(_this);
    _this.updateTetherOptions = _this.updateTetherOptions.bind(_this);
    _this.updateTetherOptions = _this.updateTetherOptions.bind(_this);
    _this.repositionTether = _this.repositionTether.bind(_this);
    _this.updateIfContentSizeChanged = _this.updateIfContentSizeChanged.bind(_this);
    return _this;
  }

  _createClass(UIAbstractPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          open = _props.open,
          zIndex = _props.zIndex;

      if (open) {
        this.createTether(zIndex);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var target = this.props.target;

      if (target != null && target !== nextProps.target) {
        this.removeTargetEventListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          open = _props2.open,
          zIndex = _props2.zIndex;

      if (!prevProps.open && open) {
        this.createTether(zIndex);
      } else if (prevProps.open && !open) {
        this.destroyTether();
      } else if (prevProps.open && open) {
        this.updateTether();
        if (prevProps.zIndex !== zIndex) this._element.style.zIndex = zIndex;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroyTether();
    }
  }, {
    key: 'addTargetEventListeners',
    value: function addTargetEventListeners() {
      var targetEl = this.getTargetElement();
      if (targetEl != null) {
        targetEl.addEventListener('load', this.updateTetherOptions, true);
      }
    }
  }, {
    key: 'removeTargetEventListeners',
    value: function removeTargetEventListeners() {
      var targetEl = this.getTargetElement();
      if (targetEl != null) {
        targetEl.removeEventListener('load', this.updateTetherOptions, true);
      }
    }
  }, {
    key: 'getRootNode',
    value: function getRootNode() {
      this._rootNode = this._rootNode || this.props.bodyElement || (0, _RootNode.getDefaultNode)();
      return this._rootNode;
    }
  }, {
    key: 'getTetherOptions',
    value: function getTetherOptions(contentEl, targetEl, bodyElement) {
      var _props3 = this.props,
          addTargetClasses = _props3.addTargetClasses,
          autoPlacement = _props3.autoPlacement,
          center = _props3.center,
          distance = _props3.distance,
          inset = _props3.inset,
          pinToConstraint = _props3.pinToConstraint,
          pinToOutOfBoundsTarget = _props3.pinToOutOfBoundsTarget,
          placement = _props3.placement,
          targetAttachment = _props3.targetAttachment;
      var _state = this.state,
          targetIsOutOfBounds = _state.targetIsOutOfBounds,
          targetIsInTransition = _state.targetIsInTransition;

      var applyConstraints = !!autoPlacement && !targetIsInTransition;
      var applyPinning = pinToOutOfBoundsTarget || !targetIsOutOfBounds;
      var offset = (0, _Placement.getOffset)(placement, distance, inset);
      var constraints = [];

      // Tether will naïvely try to flip back and forth in an infinite loop if it
      // can't satisfy our constraints, so we need to make sure we have room. Also,
      // there should be no constraints if there is no content.

      var _contentEl$getBoundin = contentEl.getBoundingClientRect(),
          height = _contentEl$getBoundin.height,
          width = _contentEl$getBoundin.width;

      if (applyConstraints && height && width) {
        var _window = window,
            innerHeight = _window.innerHeight,
            innerWidth = _window.innerWidth;

        var _targetEl$getBounding = targetEl.getBoundingClientRect(),
            top = _targetEl$getBounding.top,
            right = _targetEl$getBounding.right,
            bottom = _targetEl$getBounding.bottom,
            left = _targetEl$getBounding.left;

        var horizOffset = Number(offset.match(NUMBERS_REGEX)[1]);
        var vertOffset = Number(offset.match(NUMBERS_REGEX)[0]);
        var totalWidth = width + horizOffset;
        var totalHeight = height + vertOffset;
        var enableHorizConstraint = autoPlacement !== 'vert' && (left - totalWidth > 0 || right + totalWidth < innerWidth);
        var enableVertConstraint = autoPlacement !== 'horiz' && (top - totalHeight > 0 || bottom + totalHeight < innerHeight);
        var horizConstraint = enableHorizConstraint ? 'together' : 'none';
        var vertConstraint = enableVertConstraint ? 'together' : 'none';
        constraints = [{
          to: 'window',
          attachment: vertConstraint + ' ' + horizConstraint,
          pin: applyPinning ? pinToConstraint : false
        }];
      }

      // targetAttachment is computed based on placement and inset (a proxy for
      // whether we have an arrow), but can be overridden.
      var computedTargetAttachment = targetAttachment === 'auto' ? (0, _Placement.getTargetAttachment)(placement, center) : targetAttachment;

      return {
        addTargetClasses: addTargetClasses,
        attachment: (0, _Placement.getAttachment)(placement),
        constraints: constraints,
        element: contentEl,
        bodyElement: bodyElement,
        enabled: true,
        offset: offset,
        target: targetEl,
        targetOffset: (0, _Placement.getTargetOffset)(placement, inset),
        targetAttachment: computedTargetAttachment
      };
    }
  }, {
    key: 'handleWindowFocus',
    value: function handleWindowFocus() {
      var onFocusLeave = this.props.onFocusLeave;

      if (!this._element || !onFocusLeave) return;
      var activeEl = document.activeElement;
      if (!this._element.contains(activeEl)) {
        onFocusLeave();
      }
    }
  }, {
    key: 'handleWindowKeyDown',
    value: function handleWindowKeyDown(evt) {
      var key = evt.key;

      if (key === 'Tab') {
        this.handleTab(evt);
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(evt) {
      // Popups are appended to <body>, which means they live at the end of the document tabbing order,
      // regardless of their visual placement. So when the user presses Tab and it would take them out
      // of the Tether, they should tab to an element adjacent to the popup target.

      var targetEl = this.getTargetElement();
      if (this._element == null || targetEl == null) {
        return;
      }
      var reverseTab = evt.shiftKey;
      var activeEl = document.activeElement;

      var overrideFocusEl = void 0;
      if (this._element.contains(activeEl)) {
        overrideFocusEl = getTabTargetFromWithinPopup(this._element, activeEl, reverseTab, targetEl);
      } else if (!reverseTab && activeEl === (0, _Dom.getPrevTabbableElementInclusive)(targetEl)) {
        overrideFocusEl = (0, _underscore.first)((0, _Dom.getTabbableElements)(this._element));
      } else if (reverseTab && activeEl === (0, _Dom.getNextTabbableElementExclusive)(targetEl)) {
        overrideFocusEl = (0, _underscore.last)((0, _Dom.getTabbableElements)(this._element));
      }

      if (overrideFocusEl) {
        overrideFocusEl.focus();
        // We prevent the default tab behavior *only* if we succeeded in overriding the focus. This
        // is an escape hatch for any edge cases where overrideFocusEl isn't actually focusable. (The
        // rules of focusability are mercurial and may vary across systems/browsers.)
        if (document.activeElement === overrideFocusEl) {
          evt.preventDefault();
        }
      }
    }
  }, {
    key: 'repositionTether',
    value: function repositionTether() {
      if (this._tether && this.getRootNode().contains(this._tether.target)) {
        this._tether.position();
      }
    }
  }, {
    key: 'addImgLoadListeners',
    value: function addImgLoadListeners() {
      this._element.addEventListener('load', this.handleImageLoad, true);

      var _element$getBoundingC = this._element.getBoundingClientRect(),
          height = _element$getBoundingC.height,
          width = _element$getBoundingC.width;

      this._prevHeight = height;
      this._prevWidth = width;
    }
  }, {
    key: 'handleImageLoad',
    value: function handleImageLoad() {
      // Because loading an image may change the size of the content, we need to
      // reassess our constraints. The update also takes care of repositioning.
      if (!this._element) {
        return;
      }
      this.updateIfContentSizeChanged();
    }
  }, {
    key: 'startMutationObserver',
    value: function startMutationObserver() {
      if (this._observer || !this._element) {
        return;
      }
      var _window2 = window,
          MutationObserver = _window2.MutationObserver;

      if (!MutationObserver) {
        return; // No browser support, bummer!
      }
      // The focus should always be inside of the modal. We may need to recapture
      // it after an update because the focused element may have been unmounted.
      this._observer = new MutationObserver(this.updateIfContentSizeChanged);
      this._observer.observe(this._element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: 'stopMutationObserver',
    value: function stopMutationObserver() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }, {
    key: 'updateIfContentSizeChanged',
    value: function updateIfContentSizeChanged() {
      var _useMutationObserver = this.props._useMutationObserver;

      var _element$getBoundingC2 = this._element.getBoundingClientRect(),
          height = _element$getBoundingC2.height,
          width = _element$getBoundingC2.width;

      if (height !== this._prevHeight || width !== this._prevWidth) {
        if (_useMutationObserver) this.stopMutationObserver(); // prevent potential loop
        this.updateTetherOptions();
        if (_useMutationObserver) this.startMutationObserver();
        this._prevWidth = width;
        this._prevHeight = height;
      }
    }
  }, {
    key: 'createTether',
    value: function createTether(zIndex) {
      if (this._element) {
        this.destroyTether();
      }
      this._element = makeLayerNode(zIndex);
      this.getRootNode().appendChild(this._element);
      this.updateTether();
      this.addImgLoadListeners();
      if (this.props._useMutationObserver) {
        this.startMutationObserver();
      }

      this.addTargetEventListeners();
      window.addEventListener('focus', this.handleWindowFocus, true);
      window.addEventListener('keydown', this.handleWindowKeyDown);
      window.addEventListener('resize', this.updateTetherOptions);
      if (_reactDom2.default.createPortal) {
        this.forceUpdate();
      }
    }
  }, {
    key: 'destroyTether',
    value: function destroyTether() {
      if (this._tether) {
        this._tether.destroy();
        this._tether = null;
      }
      if (this._element) {
        this._element.parentElement.removeChild(this._element);
        if (!_reactDom2.default.createPortal) {
          _reactDom2.default.unmountComponentAtNode(this._element);
        }
        this._element = null;
      }
      // If focus has been lost, restore focus to the last element
      if (this._lastFocus) {
        var activeEl = document.activeElement;
        if (!activeEl || activeEl === document.body) {
          this._lastFocus.focus();
        }
        this._lastFocus = null;
      }
      this.stopMutationObserver();

      this.removeTargetEventListeners();
      window.removeEventListener('focus', this.handleWindowFocus, true);
      window.removeEventListener('keydown', this.handleWindowKeyDown);
      window.removeEventListener('resize', this.updateTetherOptions);
    }
  }, {
    key: 'updateTether',
    value: function updateTether() {
      var content = this.props.content;

      if (_reactDom2.default.createPortal) {
        this.updateTetherOptions();
      } else {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, content, this._element, this.updateTetherOptions);
      }
    }
  }, {
    key: 'getTargetElement',
    value: function getTargetElement() {
      var target = this.props.target;

      return target || (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: 'updateTetherOptions',
    value: function updateTetherOptions() {
      var bodyElement = this.props.bodyElement;

      var contentEl = this._element;
      var targetEl = this.getTargetElement();
      if (!contentEl || !targetEl) {
        return;
      }
      var tetherOptions = this.getTetherOptions(contentEl, targetEl, bodyElement);
      if (!this._tether) {
        this._tether = new _tether2.default(_extends({}, tetherOptions, {
          element: getDummyElement(this.getRootNode())
        }));
        this._tether.on('update', this.handleTetherUpdate);
        this._tether.setOptions(tetherOptions);
      } else {
        this._tether.setOptions(tetherOptions);
      }
    }
  }, {
    key: 'handleTetherUpdate',
    value: function handleTetherUpdate(evt) {
      var onTetherUpdate = this.props.onTetherUpdate;

      var targetEl = this.getTargetElement();
      if (!targetEl || !(0, _Dom.elementIsOnScreen)(targetEl)) {
        if (!this.state.targetIsOutOfBounds) this.setState({ targetIsOutOfBounds: true });
        return; // Ignore constraint violations caused by being completely off-screen
      }
      if (this.state.targetIsOutOfBounds) this.setState({ targetIsOutOfBounds: false });
      (0, _Functions.callIfPossible)(onTetherUpdate, evt);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          children = _props4.children,
          content = _props4.content,
          open = _props4.open;

      if (open && _reactDom2.default.createPortal && this._element) {
        var Fragment = _react2.default.Fragment || 'span';
        return _react2.default.createElement(
          Fragment,
          null,
          children || null,
          _reactDom2.default.createPortal(content, this._element)
        );
      }
      return children || null;
    }
  }]);

  return UIAbstractPopup;
}(_react.PureComponent);

UIAbstractPopup.propTypes = {
  addTargetClasses: _react.PropTypes.bool,
  autoPlacement: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horiz', 'vert'])]),
  bodyElement: _domElement2.default,
  center: _react.PropTypes.bool,
  children: _react.PropTypes.element,
  content: _react.PropTypes.node,
  distance: _react.PropTypes.number,
  inset: _react.PropTypes.number,
  onFocusLeave: _react.PropTypes.func,
  onTetherUpdate: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
  pinToOutOfBoundsTarget: _react.PropTypes.bool,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
  target: _domElement2.default,
  targetAttachment: _react.PropTypes.string,
  zIndex: _react.PropTypes.number,
  _useMutationObserver: _react.PropTypes.bool
};

UIAbstractPopup.defaultProps = {
  addTargetClasses: true,
  autoPlacement: true,
  distance: 0,
  inset: 0,
  pinToConstraint: false,
  targetAttachment: 'auto',
  zIndex: parseInt(_sizes.JUPITER_LAYER, 10),
  _useMutationObserver: false
};

UIAbstractPopup.displayName = 'UIAbstractPopup';

exports.default = UIAbstractPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/UIAbstractPopup.js
// module id = 416
// module chunks = 3 4 5